import { useEffectOnce } from 'react-use';

import { useNotify } from '@hotjar/hotsauce';
import { bus, upgradeRequestSent } from '@hotjar/webapp/utils/events';
import { useTranslation } from '@hotjar/translations';

export const useUpgradeRequestEvents = (): void => {
  const { t } = useTranslation('upsell');
  const { showToast } = useNotify();

  const showUpgradeRequestSuccessMessage = () => {
    showToast({
      kind: 'success',
      text: t('upgrade-request.success'),
    });
  };

  useEffectOnce(() => {
    const unsubscribe = bus.subscribe(upgradeRequestSent, showUpgradeRequestSuccessMessage);

    return () => {
      unsubscribe();
    };
  });
};
